// sanitizeHref returns a normalized absolute URL when `href` passes the
// protocol allowlist, or `undefined` when the URL should render as plain text.
// Resolves relative inputs against the current document.
export function sanitizeHref(href: string | undefined): string | undefined {
  if (!href) {
    return undefined;
  }

  try {
    const url = new URL(href, window.location.href);
    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return url.toString();
    }
  } catch (error) {
    console.error(`sanitizeHref: failed to parse href: '${href}'`, error);
  }

  return undefined;
}
